export const RouteNames = {
  main: "GameTeamAssignments.main",
} as const;
